export default {
  computers: (state) => state.computers,
  currentComputer: (state) => state.currentComputer,
  vaccineDeployments: (state) => state.vaccineDeployments,
  agency: (state) => state.agency,
  tags: (state) => state.tags,
  lastVersion: (state) => state.lastVersion,
  loading: (state) => state.loading,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
